import { UsersRepo } from "@services/users.repo";
import { ClientRepo } from "@services/clients/client.repo";

class AssignClientsController implements angular.IOnInit {
  public user: any;
  public clients: any[];
  public clientsForUser: any[];
  public isLoading = false;

  /** @ngInject */
  constructor(private usersRepo: UsersRepo, private clientRepo: ClientRepo,
    private $state: angular.ui.IStateService, private $stateParams: angular.ui.IStateParamsService) { }

  $onInit(): void {
    this.user = this.$stateParams.user;
    this.populateClients();
  }

  populateClients() {
    this.isLoading = true;
    this.clientRepo.searchClients({ displayAllClients: true })
      .then((resp) => {
        const clientList: any = resp.data;
        this.clients = clientList.results.map(c => ({
          clientNumber: c.clientNumber,
          name: c.name,
        }));
      })
      .catch((err) => console.log('Err:', err))
      .finally(() => this.isLoading = false)
  }

  back() {
    this.$state.go('^', { user: this.user })
  }

  cancel() {
    this.$state.go('root.users')
  }

  saveClientForUser() {
    this.isLoading = true;
    this.usersRepo.saveUserClients({ id: this.user.id, clients: this.clientsForUser.map(c => c.clientNumber) })
      .then(() => this.$state.go('root.users'))
      .catch((err) => console.log('Err:', err))
      .finally(() => this.isLoading = false)
  }
}

export const assignClients: angular.IComponentOptions = {
  controller: AssignClientsController,
  template: require('./assignClients.html')
}



// WEBPACK FOOTER //
// ./src/app/users/newUser/assignClients.ts